import React, { useEffect, useState } from "react";
import "../assets/css/shcolars.css";
import axios from "axios";
import configModule from "../../config";
import { FaAngleRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "./footer";
import dayjs from "dayjs";
import SvgContent from "../components/Svgcontent";

function FootExams() {
    const [examCourseCat, setExamCourseCat] = useState([]);
    const config = configModule.config();
    const navigate = useNavigate();

    const fetchexamCourseCat = async () => {
        try {
            const res = await axios.get(
                `${config.apiBaseUrl}/get-examcoursecat`,
                {
                    headers: {
                        "x-api-key": config.apichKey,
                    },
                }
            );

            setExamCourseCat(res?.data || []);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchexamCourseCat();
    }, []);

    return (
        <div className="scscholmain-container">
            {/* Banner */}
            <div className="cl-hero-banner" style={{ height: "92px" }}>
                <div className="cl-hero-pattern"></div>
                <div className="cl-hero-text">
                    <h2>Exams</h2>
                </div>

                <span className="breadcrumb-st" > <span className="gotohome-st" onClick={() => navigate("/")} >Home</span> <FaAngleRight className="arrow_icon" /> <b>Exams</b> </span>
            </div>

            <div className="sccontainer-st">

                <div className="exfoot-row-mainst">
                    {examCourseCat.map((item) => (
                        <div className="exfoot-innerrow-main-st"  key={item?.id}  onClick={() => navigate(`/exam-list?id=${item.id}`, {
                            state: {
                              item,
                            },
                          })}>
                            <div className="iconboxfootst" style={{ background: item?.icon_bgcolor }}>
                                <SvgContent
                                    svg_name={item.icon_class_name}
                                    height="32"
                                    width="32"
                                    stroke={item.icon_color}
                                />
                            </div>

                            <p className="textstfootex">{item.category}</p>
                        </div>
                    ))}
                </div>
            </div >

            <Footer />
        </div >
    );
}

export default FootExams;